var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomersActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0282 13.812C17.01 13.812 16.1603 13.4427 15.437 12.6722C14.712 11.8999 14.3481 10.9717 14.3481 9.84274C14.3481 8.71382 14.712 7.78561 15.437 7.01329C16.1603 6.24279 17.01 5.87354 18.0282 5.87354C19.0464 5.87354 19.8961 6.24279 20.6194 7.01329C21.3444 7.78561 21.7083 8.71382 21.7083 9.84274C21.7083 10.9717 21.3444 11.8999 20.6194 12.6722C19.8961 13.4427 19.0464 13.812 18.0282 13.812ZM9.91797 23.2504V21.0115C9.91797 20.5773 10.014 20.1665 10.2096 19.7707C10.3988 19.3877 10.6543 19.0999 10.9776 18.8888C12.0239 18.2204 13.1314 17.7206 14.3019 17.3873C15.4737 17.0536 16.7148 16.885 18.0282 16.885C19.3416 16.885 20.5827 17.0536 21.7545 17.3873C22.925 17.7206 24.0325 18.2204 25.0788 18.8888C25.4021 19.0999 25.6576 19.3877 25.8468 19.7707C26.0424 20.1665 26.1384 20.5773 26.1384 21.0115V23.2504H9.91797Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14282_15256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 14.0665V13.0791H10.1501V14.0665H0.5Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5281 7.76526H0.5V6.78955H10.8573C10.721 7.11317 10.6155 7.43936 10.5281 7.76526Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1.47571V0.5H16.0538V1.47571H0.5Z",
    fill: "white",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14282_15256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.5538,
    height: 14.5664,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomersActive);
export default __webpack_public_path__ + "static/media/CustomersActive.9425c5b7d07c1b39e4bbf3e55dce5875.svg";
export { ForwardRef as ReactComponent };